<script setup lang="ts">
import { webOfflineState as state, applyWebUpdate } from '../services/webOfflineRuntime'
</script>
<template>
  <aside v-if="state.updateReady" class="web-update-notice" role="status">
    <p>An app update is ready. Save your writing and reload to install it.</p>
    <p v-if="state.error" role="alert">{{ state.error }}</p>
    <button :disabled="state.updating" @click="applyWebUpdate">{{ state.updating ? 'Saving…' : 'Save and update' }}</button>
  </aside>
</template>
<style scoped>
.web-update-notice { position: fixed; bottom: 1rem; right: 1rem; z-index: 100000; max-width: 26rem; padding: 1rem; background: var(--bg-color, #123f3a); color: var(--text-color, #f0e3c4); border: 1px solid currentColor; border-radius: .5rem; }
</style>
